import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { Button, SvgIconHandler, SortIcon } from "../../../atoms";
import { validKeysBSchools } from "../../../../constants";

import "./sort.m.css";

export const SortDropdown = ({ isDesktop, columns, setCurrentViewFunc, activeObj }) => {
  const [selectedSortColumn, setSelectedSortColumn] = useState("Overall");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleSortColumns = (c) => () => {
    setSelectedSortColumn(c.name);

    if (validKeysBSchools.includes(c.key)) {
      setCurrentViewFunc(c.key);
    }

    setShowDropdown(false);
  };

  const handleDropDown = () => setShowDropdown(!showDropdown);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDropdown && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [showDropdown]);

  useEffect(() => {
    if (!isDesktop) {
      document.body.classList.toggle("no-scroll", showDropdown);
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [showDropdown]);

  return (
    <div styleName="wrapper">
      {!isDesktop && (
        <div
          styleName={`overlay ${showDropdown ? "overlay-active" : "overlay-inactive"}`}
          onClick={() => setShowDropdown(false)}
        ></div>
      )}
      <div ref={dropdownRef} styleName={`dropdown ${showDropdown ? "dropdown-active" : "dropdown-inactive"}`}>
        <div styleName="dropdown-heading">Group By</div>
        <div styleName="dropdown-close" onClick={() => setShowDropdown(false)}>
          <SvgIconHandler type="close" height="12" width="12" viewBox="0 0 12 12" />
        </div>
        <div>
          {columns.map((c, i) => {
            return (
              <div
                key={i}
                onClick={handleSortColumns(c)}
                styleName={`dropdown-items ${c.name === selectedSortColumn ? "dropdown-items-active" : ""}`}
              >
                {c.name}
              </div>
            );
          })}
        </div>
      </div>
      <Button onClickFunction={handleDropDown}>
        {isDesktop ? (
          <>
            {"Group by: "} <span styleName="active-item">{activeObj.name} </span>
            <SvgIconHandler type={"arrow"} width={24} height={24} viewBox="0 0 24 24" />
          </>
        ) : (
          <SortIcon />
        )}
      </Button>
    </div>
  );
};

SortDropdown.propTypes = {
  handleSort: PropTypes.func,
  isDesktop: PropTypes.string,
  columns: PropTypes.array,
};
